import { FC } from 'react';
import { PlatformData } from '@features/user/downloads/platformData.ts';
import { PlatformCard } from '@features/user/downloads/PlatformCard.tsx';

export const PlatformSelector: FC = () => {
  return (
    <div className={'flex gap-10 flex-wrap'}>
      {PlatformData.map((item) => (
        <PlatformCard key={item.id} item={item} />
      ))}
    </div>
  );
};
